
import { macroCondition, getGlobalConfig } from '@embroider/macros';


import defineModule0 from "./-embroider-implicit-modules.js";

import * as amdModule0 from "./authenticators/better-auth.ts"
import * as amdModule1 from "./builders/admin.ts"
import * as amdModule2 from "./builders/content-sources.ts"
import * as amdModule3 from "./builders/creators.ts"
import * as amdModule4 from "./builders/flags.ts"
import * as amdModule5 from "./builders/items.ts"
import * as amdModule6 from "./builders/podcasts.ts"
import * as amdModule7 from "./builders/profile.ts"
import * as amdModule8 from "./builders/stats.ts"
import * as amdModule9 from "./config/environment.ts"
import * as amdModule10 from "./deprecation-workflow.ts"
import * as amdModule11 from "./fetch.ts"
import * as amdModule12 from "./handlers/api-host-handler.ts"
import * as amdModule13 from "./handlers/auth-handler.ts"
import * as amdModule14 from "./handlers/json-api-normalizer.ts"
import * as amdModule15 from "./initializers/api-config.ts"
import * as amdModule16 from "./initializers/sentry.ts"
import * as amdModule17 from "./instance-initializers/back-button.ts"
import * as amdModule18 from "./instance-initializers/deep-links.ts"
import * as amdModule19 from "./instance-initializers/push-notifications.ts"
import * as amdModule20 from "./instance-initializers/share-intent.ts"
import * as amdModule21 from "./router.ts"
import * as amdModule22 from "./schemas/audit-log.ts"
import * as amdModule23 from "./schemas/content-source.ts"
import * as amdModule24 from "./schemas/creator.ts"
import * as amdModule25 from "./schemas/enrichment-api-call.ts"
import * as amdModule26 from "./schemas/enrichment-job.ts"
import * as amdModule27 from "./schemas/flag.ts"
import * as amdModule28 from "./schemas/item-stats.ts"
import * as amdModule29 from "./schemas/item.ts"
import * as amdModule30 from "./schemas/known-correction.ts"
import * as amdModule31 from "./schemas/llm-call.ts"
import * as amdModule32 from "./schemas/mention-with-suggested-correction.ts"
import * as amdModule33 from "./schemas/mention.ts"
import * as amdModule34 from "./schemas/pipeline-run.ts"
import * as amdModule35 from "./schemas/podcast.ts"
import * as amdModule36 from "./schemas/recipe.ts"
import * as amdModule37 from "./schemas/stats.ts"
import * as amdModule38 from "./schemas/summary.ts"
import * as amdModule39 from "./schemas/tag.ts"
import * as amdModule40 from "./schemas/user-item.ts"
import * as amdModule41 from "./schemas/user-source.ts"
import * as amdModule42 from "./schemas/user.ts"
import * as amdModule43 from "./services/language.ts"
import * as amdModule44 from "./services/lightbox.ts"
import * as amdModule45 from "./services/location.ts"
import * as amdModule46 from "./services/modals.ts"
import * as amdModule47 from "./services/network-status.ts"
import * as amdModule48 from "./services/notifications.ts"
import * as amdModule49 from "./services/offline-queue.ts"
import * as amdModule50 from "./services/push-notifications.ts"
import * as amdModule51 from "./services/session.ts"
import * as amdModule52 from "./services/share-intent.ts"
import * as amdModule53 from "./services/store.ts"
import * as amdModule54 from "./services/theme.ts"
import * as amdModule55 from "./session-stores/application.ts"
import * as amdModule56 from "./types/lightbox.ts"
import * as amdModule57 from "./types/modal.ts"
import * as amdModule58 from "./types/notification.ts"
import * as amdModule59 from "./utils/api-types.ts"
import * as amdModule60 from "./utils/camel-case-keys.ts"
import * as amdModule61 from "./utils/chunk-array.ts"
import * as amdModule62 from "./utils/distance.ts"
import * as amdModule63 from "./utils/enriched-data.ts"
import * as amdModule64 from "./utils/external-urls.ts"
import * as amdModule65 from "./utils/format.ts"
import * as amdModule66 from "./utils/geolocation.ts"
import * as amdModule67 from "./utils/local-storage.ts"
import * as amdModule68 from "./utils/map.ts"
import * as amdModule69 from "./utils/native-platform.ts"
import * as amdModule70 from "./utils/offline-db.ts"
import * as amdModule71 from "./utils/pipeline-colors.ts"
import * as amdModule72 from "./utils/pipeline-types.ts"
import * as amdModule73 from "./utils/preferences.ts"
import * as amdModule74 from "./utils/sentry.ts"
import * as amdModule75 from "./utils/tr-keys.ts"
import * as amdModule76 from "./utils/url-preview.ts"
import * as amdModule77 from "./authenticators/jwt.js"
import * as amdModule78 from "./authenticators/token.js"
import * as amdModule79 from "./initializers/ember-simple-auth.js"
import * as amdModule80 from "./services/cookies.js"
import * as amdModule81 from "./services/page-title.js"
import * as amdModule82 from "./services/intl.js"
import * as amdModule83 from "./data-adapter.js"
import * as amdModule84 from "./templates/explore.gts"
import * as amdModule85 from "./routes/explore.ts"
import * as amdModule86 from "./templates/explore/index.gts"
import * as amdModule87 from "./routes/explore/index.ts"
import * as amdModule88 from "./templates/explore/index/results.gts"
import * as amdModule89 from "./controllers/explore/index/results.ts"
import * as amdModule90 from "./routes/explore/index/results.ts"
import * as amdModule91 from "./templates/explore/index/results-error.gts"
import * as amdModule92 from "./templates/explore/index/results-loading.gts"
import * as amdModule93 from "./templates/explore/recipe.gts"
import * as amdModule94 from "./routes/explore/recipe.ts"
import * as amdModule95 from "./templates/explore/show.gts"
import * as amdModule96 from "./routes/explore/show.ts"
import * as amdModule97 from "./templates/explore/index-error.gts"
import * as amdModule98 from "./templates/explore/index-loading.gts"
import * as amdModule99 from "./templates/explore/recipe-error.gts"
import * as amdModule100 from "./templates/explore/recipe-loading.gts"
import * as amdModule101 from "./templates/explore/show-error.gts"
import * as amdModule102 from "./templates/explore/show-loading.gts"
import * as amdModule103 from "./templates/places.gts"
import * as amdModule104 from "./controllers/places.ts"
import * as amdModule105 from "./routes/places.ts"
import * as amdModule106 from "./templates/application.gts"
import * as amdModule107 from "./routes/application.ts"
import * as amdModule108 from "./templates/auto-login.gts"
import * as amdModule109 from "./routes/auto-login.ts"
import * as amdModule110 from "./templates/collections.gts"
import * as amdModule111 from "./routes/collections.ts"
import * as amdModule112 from "./templates/extract.gts"
import * as amdModule113 from "./routes/extract.ts"
import * as amdModule114 from "./templates/index.gts"
import * as amdModule115 from "./routes/index.ts"
import * as amdModule116 from "./templates/items.gts"
import * as amdModule117 from "./routes/items.ts"
import * as amdModule118 from "./templates/items/show.gts"
import * as amdModule119 from "./routes/items/show.ts"
import * as amdModule120 from "./templates/items/index.gts"
import * as amdModule121 from "./templates/items/show-error.gts"
import * as amdModule122 from "./templates/link-account.gts"
import * as amdModule123 from "./routes/link-account.ts"
import * as amdModule124 from "./templates/login.gts"
import * as amdModule125 from "./routes/login.ts"
import * as amdModule126 from "./templates/my-account.gts"
import * as amdModule127 from "./routes/my-account.ts"
import * as amdModule128 from "./templates/not-found.gts"
import * as amdModule129 from "./routes/not-found.ts"
import * as amdModule130 from "./templates/search.gts"
import * as amdModule131 from "./routes/search.ts"
import * as amdModule132 from "./templates/share.gts"
import * as amdModule133 from "./routes/share.ts"
import * as amdModule134 from "./templates/sources.gts"
import * as amdModule135 from "./routes/sources.ts"
import * as amdModule136 from "./templates/sources/show.gts"
import * as amdModule137 from "./routes/sources/show.ts"
import * as amdModule138 from "./templates/sources/index.gts"
import * as amdModule139 from "./templates/sources/show-error.gts"
import * as amdModule140 from "./templates/sources/show-loading.gts"
import * as amdModule141 from "./templates/verified.gts"
import * as amdModule142 from "./routes/verified.ts"
import * as amdModule143 from "./templates/admin-loading.gts"
import * as amdModule144 from "./templates/application-error.gts"
import * as amdModule145 from "./templates/collections-error.gts"
import * as amdModule146 from "./templates/collections-loading.gts"
import * as amdModule147 from "./templates/explore-loading.gts"
import * as amdModule148 from "./templates/items-error.gts"
import * as amdModule149 from "./templates/items-loading.gts"
import * as amdModule150 from "./templates/search-error.gts"
import * as amdModule151 from "./templates/search-loading.gts"
import * as amdModule152 from "./templates/sources-error.gts"
import * as amdModule153 from "./templates/sources-loading.gts"

let exportFastbootModules = {};





export default Object.assign(
  {},
defineModule0,
  {
"favoris-web/authenticators/better-auth": amdModule0,
"favoris-web/builders/admin": amdModule1,
"favoris-web/builders/content-sources": amdModule2,
"favoris-web/builders/creators": amdModule3,
"favoris-web/builders/flags": amdModule4,
"favoris-web/builders/items": amdModule5,
"favoris-web/builders/podcasts": amdModule6,
"favoris-web/builders/profile": amdModule7,
"favoris-web/builders/stats": amdModule8,
"favoris-web/config/environment": amdModule9,
"favoris-web/deprecation-workflow": amdModule10,
"favoris-web/fetch": amdModule11,
"favoris-web/handlers/api-host-handler": amdModule12,
"favoris-web/handlers/auth-handler": amdModule13,
"favoris-web/handlers/json-api-normalizer": amdModule14,
"favoris-web/initializers/api-config": amdModule15,
"favoris-web/initializers/sentry": amdModule16,
"favoris-web/instance-initializers/back-button": amdModule17,
"favoris-web/instance-initializers/deep-links": amdModule18,
"favoris-web/instance-initializers/push-notifications": amdModule19,
"favoris-web/instance-initializers/share-intent": amdModule20,
"favoris-web/router": amdModule21,
"favoris-web/schemas/audit-log": amdModule22,
"favoris-web/schemas/content-source": amdModule23,
"favoris-web/schemas/creator": amdModule24,
"favoris-web/schemas/enrichment-api-call": amdModule25,
"favoris-web/schemas/enrichment-job": amdModule26,
"favoris-web/schemas/flag": amdModule27,
"favoris-web/schemas/item-stats": amdModule28,
"favoris-web/schemas/item": amdModule29,
"favoris-web/schemas/known-correction": amdModule30,
"favoris-web/schemas/llm-call": amdModule31,
"favoris-web/schemas/mention-with-suggested-correction": amdModule32,
"favoris-web/schemas/mention": amdModule33,
"favoris-web/schemas/pipeline-run": amdModule34,
"favoris-web/schemas/podcast": amdModule35,
"favoris-web/schemas/recipe": amdModule36,
"favoris-web/schemas/stats": amdModule37,
"favoris-web/schemas/summary": amdModule38,
"favoris-web/schemas/tag": amdModule39,
"favoris-web/schemas/user-item": amdModule40,
"favoris-web/schemas/user-source": amdModule41,
"favoris-web/schemas/user": amdModule42,
"favoris-web/services/language": amdModule43,
"favoris-web/services/lightbox": amdModule44,
"favoris-web/services/location": amdModule45,
"favoris-web/services/modals": amdModule46,
"favoris-web/services/network-status": amdModule47,
"favoris-web/services/notifications": amdModule48,
"favoris-web/services/offline-queue": amdModule49,
"favoris-web/services/push-notifications": amdModule50,
"favoris-web/services/session": amdModule51,
"favoris-web/services/share-intent": amdModule52,
"favoris-web/services/store": amdModule53,
"favoris-web/services/theme": amdModule54,
"favoris-web/session-stores/application": amdModule55,
"favoris-web/types/lightbox": amdModule56,
"favoris-web/types/modal": amdModule57,
"favoris-web/types/notification": amdModule58,
"favoris-web/utils/api-types": amdModule59,
"favoris-web/utils/camel-case-keys": amdModule60,
"favoris-web/utils/chunk-array": amdModule61,
"favoris-web/utils/distance": amdModule62,
"favoris-web/utils/enriched-data": amdModule63,
"favoris-web/utils/external-urls": amdModule64,
"favoris-web/utils/format": amdModule65,
"favoris-web/utils/geolocation": amdModule66,
"favoris-web/utils/local-storage": amdModule67,
"favoris-web/utils/map": amdModule68,
"favoris-web/utils/native-platform": amdModule69,
"favoris-web/utils/offline-db": amdModule70,
"favoris-web/utils/pipeline-colors": amdModule71,
"favoris-web/utils/pipeline-types": amdModule72,
"favoris-web/utils/preferences": amdModule73,
"favoris-web/utils/sentry": amdModule74,
"favoris-web/utils/tr-keys": amdModule75,
"favoris-web/utils/url-preview": amdModule76,
"favoris-web/authenticators/jwt": amdModule77,
"favoris-web/authenticators/token": amdModule78,
"favoris-web/initializers/ember-simple-auth": amdModule79,
"favoris-web/services/cookies": amdModule80,
"favoris-web/services/page-title": amdModule81,
"favoris-web/services/intl": amdModule82,
"favoris-web/data-adapter": amdModule83,
"favoris-web/templates/explore": amdModule84,
"favoris-web/routes/explore": amdModule85,
"favoris-web/templates/explore/index": amdModule86,
"favoris-web/routes/explore/index": amdModule87,
"favoris-web/templates/explore/index/results": amdModule88,
"favoris-web/controllers/explore/index/results": amdModule89,
"favoris-web/routes/explore/index/results": amdModule90,
"favoris-web/templates/explore/index/results-error": amdModule91,
"favoris-web/templates/explore/index/results-loading": amdModule92,
"favoris-web/templates/explore/recipe": amdModule93,
"favoris-web/routes/explore/recipe": amdModule94,
"favoris-web/templates/explore/show": amdModule95,
"favoris-web/routes/explore/show": amdModule96,
"favoris-web/templates/explore/index-error": amdModule97,
"favoris-web/templates/explore/index-loading": amdModule98,
"favoris-web/templates/explore/recipe-error": amdModule99,
"favoris-web/templates/explore/recipe-loading": amdModule100,
"favoris-web/templates/explore/show-error": amdModule101,
"favoris-web/templates/explore/show-loading": amdModule102,
"favoris-web/templates/places": amdModule103,
"favoris-web/controllers/places": amdModule104,
"favoris-web/routes/places": amdModule105,
"favoris-web/templates/application": amdModule106,
"favoris-web/routes/application": amdModule107,
"favoris-web/templates/auto-login": amdModule108,
"favoris-web/routes/auto-login": amdModule109,
"favoris-web/templates/collections": amdModule110,
"favoris-web/routes/collections": amdModule111,
"favoris-web/templates/extract": amdModule112,
"favoris-web/routes/extract": amdModule113,
"favoris-web/templates/index": amdModule114,
"favoris-web/routes/index": amdModule115,
"favoris-web/templates/items": amdModule116,
"favoris-web/routes/items": amdModule117,
"favoris-web/templates/items/show": amdModule118,
"favoris-web/routes/items/show": amdModule119,
"favoris-web/templates/items/index": amdModule120,
"favoris-web/templates/items/show-error": amdModule121,
"favoris-web/templates/link-account": amdModule122,
"favoris-web/routes/link-account": amdModule123,
"favoris-web/templates/login": amdModule124,
"favoris-web/routes/login": amdModule125,
"favoris-web/templates/my-account": amdModule126,
"favoris-web/routes/my-account": amdModule127,
"favoris-web/templates/not-found": amdModule128,
"favoris-web/routes/not-found": amdModule129,
"favoris-web/templates/search": amdModule130,
"favoris-web/routes/search": amdModule131,
"favoris-web/templates/share": amdModule132,
"favoris-web/routes/share": amdModule133,
"favoris-web/templates/sources": amdModule134,
"favoris-web/routes/sources": amdModule135,
"favoris-web/templates/sources/show": amdModule136,
"favoris-web/routes/sources/show": amdModule137,
"favoris-web/templates/sources/index": amdModule138,
"favoris-web/templates/sources/show-error": amdModule139,
"favoris-web/templates/sources/show-loading": amdModule140,
"favoris-web/templates/verified": amdModule141,
"favoris-web/routes/verified": amdModule142,
"favoris-web/templates/admin-loading": amdModule143,
"favoris-web/templates/application-error": amdModule144,
"favoris-web/templates/collections-error": amdModule145,
"favoris-web/templates/collections-loading": amdModule146,
"favoris-web/templates/explore-loading": amdModule147,
"favoris-web/templates/items-error": amdModule148,
"favoris-web/templates/items-loading": amdModule149,
"favoris-web/templates/search-error": amdModule150,
"favoris-web/templates/search-loading": amdModule151,
"favoris-web/templates/sources-error": amdModule152,
"favoris-web/templates/sources-loading": amdModule153,
  },
  exportFastbootModules
);
